import templateOnlyComponent from '@ember/component/template-only';

interface AditoolsSectionHeaderSignature {
  Element: HTMLDivElement;
  Args: {
    title: string;
  };
}

const AditoolsSectionHeader = templateOnlyComponent<AditoolsSectionHeaderSignature>();

export default AditoolsSectionHeader;
